import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { removeCookie, setCookie } from "../../utils/cookies";
// components
import WelcomeView from "./welcomeView/welcomeView";
import QuestionsView from "./questionsView";
import Results from './results';
// services
import { logoutUser } from '../../services/users';

const TestView = ({ evaluation, results, aboutTest, getTest, startedTest, drawQuestions, finishedTest }) => {
	const dispatch = useDispatch();
	//const [testStart, setTestStart] = useState(false);
	const [unansweredQuestions, setUnansweredQuestions] = useState([]);

	useEffect(() => {
		if (Object.keys(results).length) {
			//setTestStart(true);
			console.log("Volvió a entrar al test");
			//setCookie("timer", 90);
		}

		// filter answered questions
		if (evaluation.questions) {
			const remainingQuestions = evaluation.questions.filter((question) => {
				let answered = false;
				Object.keys(results).forEach((answerId) => {
					if (question.id == answerId) {
						answered = true;
					}
				});
				return !answered;
			});
			setUnansweredQuestions(remainingQuestions);
		}
	}, [results]);

	const logout = () => {
		removeCookie("userId");
		removeCookie("mentaliaUserToken");
		removeCookie("timer");
		removeCookie("email");
		logoutUser();

		// // Redux action
		dispatch({
			type: "SET_USER_INFO",
			payload: {},
		});
	};

	return (
		<TestStyled>
			{unansweredQuestions.length && !finishedTest ? (
				<QuestionsView
					questions={unansweredQuestions}
					totalQuestions={evaluation.questions_count}
					answredQuestions={Object.keys(results).length + 1}
				/>
			) : !finishedTest ? (
				<WelcomeView
					aboutTest={aboutTest}
					getTest={getTest}
					startedTest={startedTest}
					drawQuestions={drawQuestions}
				/>
			) :
				<Results resultsInfo={finishedTest} />
			}
		</TestStyled>
	);
};

const TestStyled = styled.section`
			.instructions {
				box-sizing: border-box;
				justify-content: center;
				display: flex;
				min-height: calc(100vh - 80px);
				flex-direction: column;
				text-align: center;
				padding-bottom: 2em;
				max-width: 600px;
				margin: 0 auto;
			}
			`;

export default TestView;
